@if (isLoading) {
  <div class="spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
}

<h1 class="title">Upscaling Absolute Permeability search</h1>

<mat-card class="fluid-flow-card">
  <div class="search">
    <mat-form-field appearance="outline" class="search-by-input">
      <mat-label>Search By</mat-label>
      <mat-select [(ngModel)]="searchBy" id="upscaling-fluid-flow-search-by-filter-select">
        <mat-option value="name">Name</mat-option>
        <mat-option value="user">User</mat-option>
        <mat-option value="rockFile">Rock file</mat-option>
        <mat-option value="rockModel">Upscaling Rock Model</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="search-input-wrapper">
      <mat-label>Search simulations</mat-label>
      <input
        matInput
        [(ngModel)]="searchString"
        id="upscaling-fluid-flow-search-input"
        class="search-input"
      />
    </mat-form-field>

    <div class="button-group">
      <button mat-flat-button color="primary" class="search-btn" (click)="onSearchClick()">
        <mat-icon>search</mat-icon>
        <span>Search</span>
      </button>

      <button mat-flat-button color="secondary" class="filter-btn" (click)="onFilterClick()">
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>
  </div>

  <div class="table-wrapper">
    <table
      mat-table
      [dataSource]="dataSource"
      class="table custom-table minimized-table mat-elevation-z2"
    >
      <!-- Name -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="main-header">Name</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <!-- Direction X -->
      <ng-container matColumnDef="directionX">
        <th mat-header-cell *matHeaderCellDef class="main-header">Direction X</th>
        <td mat-cell *matCellDef="let row">{{ row.directionX }}</td>
      </ng-container>

      <!-- Direction Y -->
      <ng-container matColumnDef="directionY">
        <th mat-header-cell *matHeaderCellDef class="main-header">Direction<br/>Y</th>
        <td mat-cell *matCellDef="let row">{{ row.directionY }}</td>
      </ng-container>

      <!-- Direction Z -->
      <ng-container matColumnDef="directionZ">
        <th mat-header-cell *matHeaderCellDef class="main-header">Direction Z</th>
        <td mat-cell *matCellDef="let row">{{ row.directionZ }}</td>
      </ng-container>

      <!-- View -->
      <ng-container matColumnDef="view">
        <th mat-header-cell *matHeaderCellDef class="main-header">View</th>
        <td mat-cell *matCellDef="let row">
          <button
            mat-flat-button
            color="secondary"
            (click)="onViewResults(row)"
          >
            <mat-icon>open_in_new</mat-icon>
            Results
          </button>
        </td>
      </ng-container>

      <!-- Rock file -->
      <ng-container matColumnDef="rockFile">
        <th mat-header-cell *matHeaderCellDef class="main-header">Rock file</th>
        <td mat-cell *matCellDef="let row">
          {{ row.rockFile | removeExtension }}
        </td>
      </ng-container>

      <!-- Upscaling Rock Model -->
      <ng-container matColumnDef="upscalingRockModel">
        <th mat-header-cell *matHeaderCellDef class="main-header">Upscaling Rock Model</th>
        <td mat-cell *matCellDef="let row">
          {{ row.upscalingRockModel }}
        </td>
      </ng-container>

      <!-- User -->
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef class="main-header">User</th>
        <td mat-cell *matCellDef="let row">{{ row.user }}</td>
      </ng-container>

      <!-- Created at -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef class="main-header">Created at</th>
        <td mat-cell *matCellDef="let row">
          {{ row.createdAt | date : 'dd-MM-yyyy' }}<br />
          {{ row.createdAt | date : 'h:mm a' }}
        </td>
      </ng-container>

      <!-- Completed at -->
      <ng-container matColumnDef="completedAt">
        <th mat-header-cell *matHeaderCellDef class="main-header">Completed at</th>
        <td mat-cell *matCellDef="let row">
          {{ row.completedAt | date : 'dd-MM-yyyy' }}<br />
          {{ row.completedAt | date : 'h:mm a' }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="onRowClick(row)"
        [class.selected]="row.simulationId === selectedRow?.simulationId"
      ></tr>
    </table>
  </div>

  <mat-paginator
    class="mat-paginator"
    [length]="count"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 20, 30]"
    aria-label="Select page"
    (page)="onPageChange($event)"
  ></mat-paginator>

  <div class="card-footer">
    <button
      class="btn btn-primary icon-btn"
      type="button"
      [disabled]="!selectedRow"
      (click)="goToFluidFlowModelsManager()"
    >
      <mat-icon>layers</mat-icon>
      <span>Fluid Flow Models</span>
    </button>
  </div>
</mat-card>

